import React, { memo } from 'react';
import type { ControlRendererProps } from '../ControlRenderer';
import { getBaseControlClassName } from '../utils/classNameUtils';

const LinkControl = memo<ControlRendererProps>(({ control }) => {
  const containerClassName = getBaseControlClassName(control, {
    disabled: control.disabled,
  });

  const href = (control.config?.href as string) || undefined;
  const target = (control.config?.target as string) || '_self';
  const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
  const text = control.label || href || '';

  return (
    <div className={containerClassName}>
      {href ? (
        <a
          id={control.id}
          href={href}
          target={target}
          rel={rel}
          className="control__link"
        >
          {text}
        </a>
      ) : (
        <span id={control.id} className="control__link control__link--empty">
          {text || '(no URL configured)'}
        </span>
      )}

      {control.helpText && (
        <div className="control__help">{control.helpText}</div>
      )}
    </div>
  );
});

LinkControl.displayName = 'LinkControl';

export default LinkControl;
